import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { TenantDto } from '@picflow/types';
import { getAllRouteParams } from '../../lib/get-all-route-params';
import { getFullPath } from '../../lib/get-full-path';
import { BrowserService } from '../../services/browser.service';
import { GalleryService } from '../../services/gallery.service';
import { RedirectService } from '../../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryRedirectGuard {
  constructor(
    private redirectService: RedirectService,
    private galleryService: GalleryService,
    private browserService: BrowserService
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    if (!next.queryParams.autoRedirect) return true;
    const params = getAllRouteParams(next);
    if (!params.galleryPath) return true;

    try {
      const path = getFullPath(next);
      const gallery = await this.galleryService.getPublicGalleryFromSnapshot(next);

      const query = { ...next.queryParams };
      delete query.autoRedirect;
      const searchParams = new URLSearchParams(query);
      const searchParamsString = searchParams.toString() ? `?${searchParams.toString()}` : '';
      const origin = this.browserService.getCorrectPicflowUrl().split('://')[1];
      const url = `https://${(gallery.tenant as TenantDto).path}.${origin}/${gallery.path}/${path.slice(
        path.findIndex(p => p === params.galleryPath) + 1
      )}${searchParamsString}`;
      this.redirectService.externalRedirectTo(url);
    } catch (err) {
      return true;
    }
  }
}
